import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

export interface TipsDialogData {
  returnAmount: number;
  decimalsString: string;
  currencySymbol: string;
}

@Component({
  selector: 'app-tips-dialog',
  templateUrl: './tips-dialog.component.html',
  styleUrls: ['./tips-dialog.component.css']
})
export class TipsDialogComponent {
  selectedTip: number | null = null;
  tipOptions: (number | 'arrondi')[] = ['arrondi', 10, 15, 20];
  freeAmount = 0;
  useFreeAmount = false;

  constructor(
    public dialogRef: MatDialogRef<TipsDialogComponent>,
    public cssService: CssService,
    @Inject(MAT_DIALOG_DATA) public data: TipsDialogData
  ) { }

  isClosing = false;

  selectTipOption(tip: number | 'arrondi') {
    switch (tip) {
      case ('arrondi'): {
        this.useFreeAmount = true;        // On passe forcément en montant libre
        this.selectedTip = null;          // On désélectionne les pourcentages
        const roundUp = Math.ceil(this.data.returnAmount); // arrondi au int sup
        this.freeAmount = roundUp - this.data.returnAmount;
        this.freeAmount = this.roundedThisNumber(this.freeAmount);
        break;
      }
      default: {
        this.selectedTip = tip;
        this.useFreeAmount = false;
        this.freeAmount = this.calculateTipAmount(tip);
        this.freeAmount = this.roundedThisNumber(this.freeAmount);
        break
      }
    }
  }

  roundedThisNumber(thisNumber: number) {
    return Math.round(thisNumber * 100) / 100;
  }

  increaseFreeAmount(): void {
    this.freeAmount += 0.5; // Ajoute 0.5€ à chaque clic
    this.useFreeAmount = true;
    this.selectedTip = null; // On désélectionne les boutons de pourcentage
    this.freeAmount = this.roundedThisNumber(this.freeAmount);
  }

  decreaseFreeAmount(): void {
    this.freeAmount -= 0.5;
    if (this.freeAmount < 0) {
      this.freeAmount = 0;
    } else {
      this.freeAmount = this.roundedThisNumber(this.freeAmount);
    }
    this.useFreeAmount = true;
    this.selectedTip = null;
  }

  onFreeAmountChange(): void {
    this.useFreeAmount = true;
    this.selectedTip = null;
    this.freeAmount = this.roundedThisNumber(this.freeAmount);
  }

  calculateTipAmount(percent: number): number {
    return this.roundedThisNumber((percent / 100) * this.data.returnAmount);
  }

  getDisplayedTipAmount(): number {
    return this.useFreeAmount ? this.freeAmount : this.calculateTipAmount(this.selectedTip || 0);
  }

  onConfirm(): void {
    if (this.useFreeAmount) {
      this.dialogRef.close(this.freeAmount);
    } else if (this.selectedTip !== null) {
      this.dialogRef.close(this.calculateTipAmount(this.selectedTip));
    } else {
      this.dialogRef.close(0);
    }
  }

  onCancel() {
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing) {
      this.dialogRef.close(0);
    }
  }
}
